import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { StoreButton } from "./StoreButton";
import { Wordmark } from "./Logo";
import { Reveal } from "./Reveal";
import { Lock } from "lucide-react";

export const CTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section id="download" ref={ref} data-testid="download-section" className="relative overflow-hidden py-28 sm:py-40">
      <motion.img src="/img/mist.jpg" alt="" style={{ y, scale: 1.25 }} className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050911] via-[#050911]/70 to-[#050911]" />
      <Reveal className="relative mx-auto max-w-5xl px-5 sm:px-8">
        <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-[#F59E0B]">// Beta season is open</p>
        <h2 className="font-display text-5xl sm:text-8xl font-black uppercase leading-[0.88] tracking-tight text-white">
          Be first<br /><span className="text-outline">on the water.</span>
        </h2>
        <p className="mt-6 max-w-lg text-base md:text-lg text-slate-300">Angler League is in beta and live on the App Store. Download it, join a league and help shape what comes next.</p>
        <div className="mt-8"><StoreButton id="footer" /></div>
      </Reveal>
    </section>
  );
};

export const Footer = () => (
  <footer className="border-t border-cyan-400/10 px-5 sm:px-8 py-10">
    <div className="mx-auto flex max-w-7xl flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <Wordmark />
      <div className="flex items-center gap-6">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">© {new Date().getFullYear()} Angler League · Catch. Compete. Climb.</p>
        <a href="/admin" data-testid="footer-admin-link" className="flex items-center gap-1.5 font-mono text-xs uppercase tracking-[0.2em] text-slate-400 hover:text-[#00E5FF] transition-colors">
          <Lock className="h-3.5 w-3.5" /> Admin
        </a>
      </div>
    </div>
  </footer>
);
